// extracted by mini-css-extract-plugin
export default {"imageWrapper":"JK-z","twoColumnImage":"KK-z"};